import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { A11yModule, FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { TimeEntry } from '../models/time-entry';
import { TimesheetService } from '../services/time-sheet.service';
import { firstValueFrom, NEVER, race, timeout } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-notes',
    imports: [
    A11yModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    DragDropModule,
    MatIconModule,
    MatProgressSpinner
],
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss']
})
export class NotesComponent {

  notesControl!: FormControl;
  title: string;
  saving = false;
  lastSaveMessage = "";

  constructor(
    public dialogRef: MatDialogRef<NotesComponent>,
    public timesheetService: TimesheetService,
    @Inject(MAT_DIALOG_DATA) public data: { notes: string, weekStart: string, projectId: number, day: string, timeTypeId: number, readonly: boolean },
  ) {
    this.notesControl = new FormControl<string>(this.data.notes || '');
    this.title = data.readonly ? "Notes" : "Edit Notes";
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  async onSave() {
    if (this.data.readonly) {
      console.error("Shouldn't be able to click save when dialog readonly.");
      return;
    }

    const entry = new TimeEntry();
    entry.notes = this.notesControl.value || '';
    entry.recordedTime = -1;
    entry.projectId = this.data.projectId;
    entry.dateEntry = this.data.day;
    entry.timeTypeId = this.data.timeTypeId;
    try {
      this.saving = true;
      // const updateOrError = race(this.timesheetService.updateTimesheet([entry], this.data.weekStart, false), NEVER.pipe(timeout(10000)));
      await firstValueFrom(this.timesheetService.updateTimesheet([entry], this.data.weekStart, false).pipe(timeout(10000)));
      this.saving = false;
      this.dialogRef.close();
    } catch (err) {
      this.saving = false;
      this.lastSaveMessage = "There was an error while trying to save. Please try again.";
    }
  }
}